import React, { Component, PropTypes } from "react";
import styled from "styled-components";

const HeaderContainer = styled.div`
  position: fixed;
  height:${props => (props.isHide ? 0 : props.scrollHeight)}px;
  left:0;
  top:0;
  background-color: ${props => props.theme.color[props.variant]};
  width:100%;
  text-align:center;
  font-size:22px;
  box-shadow: 0px 3px 3px rgba(0,0,0,0.3);
  transition: height 0.3s ease-in;
  z-index:999;
 `;

const HeaderContent = styled.div`
 margin: auto;
 visibility:${props => (props.isHide ? "hidden" : "visible")};
 opacity:${props => (props.isHide ? 0 : 1)};
 transition:opacity 1s linear;

 `;

class FloatingStickyHeader extends React.Component {
	constructor(props) {
		super(props);
		this.state = { isHide: true, displayHeaderScrollHeight: 0 };
		this.hideBar = this.hideBar.bind(this);
	}
	hideBar() {
		let { isHide, displayHeaderScrollHeight } = this.state;
		if (window.scrollY > displayHeaderScrollHeight) {
			this.setState({ isHide: false });
			this.props.callBack(true);
		} else {
			this.setState({ isHide: true });
			this.props.callBack(false);
		}

		this.prev = window.scrollY;
	}
	componentDidMount() {
		window.addEventListener("scroll", this.hideBar);
		this.setState({
			displayHeaderScrollHeight: this.props.displayHeaderScrollHeight
		});
	}
	componentWillUnmount() {
		window.removeEventListener("scroll", this.hideBar);
	}

	render() {
		//let classHide = this.state.isHide ? "hide" : "";
		const { headerHeight, children, variant } = this.props;
		return (
			<HeaderContainer
				variant={variant}
				isHide={this.state.isHide}
				scrollHeight={headerHeight}>
				<HeaderContent isHide={this.state.isHide}>
					{children}
				</HeaderContent>
			</HeaderContainer>
		);
	}
}

FloatingStickyHeader.propTypes = {
	displayHeaderScrollHeight: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]), //At what height of scroll should the header be displayed
	headerHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

FloatingStickyHeader.defaultProps = {
	headerHeight: 65,
	displayHeaderScrollHeight: 500,
	children: PropTypes.object,
	variant: PropTypes.string,
	callBack: PropTypes.func
};

export default FloatingStickyHeader;



// WEBPACK FOOTER //
// ./src/layouts/fleet/FloatingStickyHeader.js